export default __webpack_public_path__ + "static/media/misc-pantry2-2048w.e5003031.webp";